// extracted by mini-css-extract-plugin
module.exports = {"button":"e2ff468f85--button--bOE0r","pin-icon":"e2ff468f85--pin-icon--lp8hE","title":"e2ff468f85--title--lswiQ"};